import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 px-4">
      <img src="/icon.png" alt="Lockwaste" className="h-16 w-16 mb-6 rounded-xl" />
      <h1 className="text-6xl font-extrabold text-slate-800 mb-2">404</h1>
      <p className="text-xl text-slate-500 mb-8">Page not found</p>
      <button
        onClick={() => navigate('/login')}
        className="px-6 py-3 bg-indigo-600 text-white rounded-xl hover:bg-indigo-700 transition-colors font-semibold shadow-sm"
      >
        Go to Login
      </button>
    </div>
  );
};

export default NotFound;
